import { render, staticRenderFns } from "./corporate-number.vue?vue&type=template&id=0152035d&scoped=true&"
import script from "./corporate-number.vue?vue&type=script&lang=js&"
export * from "./corporate-number.vue?vue&type=script&lang=js&"
import style0 from "./corporate-number.vue?vue&type=style&index=0&id=0152035d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0152035d",
  null
  
)

export default component.exports